/* OFFALS & BONES · landing page behaviour (no dependencies).
   Preview phase switch, reveal/parallax, gallery filter + lightbox, sketch/ink slider,
   in-view video, countdown, AJAX add to cart (Focal cart drawer events), analytics hooks. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parse(v) { var t = Date.parse(v || ''); return isNaN(t) ? null : t; }

  function track(name, label) {
    var detail = { event: 'ob_' + name, ob_label: label || '', ob_page: 'offals-and-bones' };
    try { (window.dataLayer = window.dataLayer || []).push(detail); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ob_' + name, detail); } catch (e) {}
  }

  function phaseAt(root, t) {
    var a = parse(root.getAttribute('data-archive')), l = parse(root.getAttribute('data-live'));
    if (a !== null && t >= a) return 'archive';
    if (l !== null && t >= l) return 'live';
    return 'prelaunch';
  }

  function mountPreview(root) {
    var qs = new URLSearchParams(location.search);
    var want = (qs.get('ob_phase') || '').toLowerCase();
    if (['prelaunch', 'live', 'archive'].indexOf(want) < 0) {
      want = root.getAttribute('data-mode') === 'auto' ? phaseAt(root, Date.now()) : root.getAttribute('data-phase');
    }
    var tpl = root.querySelector('template[data-ob-phase="' + want + '"]');
    var mount = root.querySelector('[data-ob-mount]');
    if (tpl && mount) mount.replaceWith(tpl.content.cloneNode(true));
    root.setAttribute('data-view-phase', want);
    if (window.Shopify && Shopify.designMode) return; // the theme editor is its own preview
    var bar = document.createElement('div');
    bar.className = 'ob-preview-bar';
    var names = { prelaunch: 'Pre-launch', live: 'Live exhibition', archive: 'Post-exhibition' };
    bar.innerHTML = '<b>Test preview</b> · ' + Object.keys(names).map(function (p) {
      var u = new URL(location.href); u.searchParams.set('ob_phase', p);
      return '<a href="' + u.pathname + u.search + '"' + (p === want ? ' aria-current="true"' : '') + '>' + names[p] + '</a>';
    }).join('');
    document.body.appendChild(bar);
  }

  function reveal(root) {
    var els = root.querySelectorAll('.ob-reveal');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function parallax(root) {
    if (reduce) return;
    var items = [].slice.call(root.querySelectorAll('[data-ob-parallax]'));
    if (!items.length) return;
    var ticking = false;
    function run() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-ob-parallax')) || 0.05;
        el.style.translate = '0 ' + ((r.top + r.height / 2 - vh / 2) * -k).toFixed(1) + 'px';
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function filters(root) {
    root.querySelectorAll('[data-ob-filter-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sec = btn.closest('section'), f = btn.getAttribute('data-ob-filter-btn');
        sec.querySelectorAll('[data-ob-filter-btn]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        sec.querySelectorAll('.ob-card').forEach(function (c) {
          c.hidden = !(f === 'all' || c.getAttribute('data-ob-filter') === f);
          if (!c.hidden) c.classList.add('is-in');
        });
        track('filter', f);
      });
    });
  }

  function lightbox(root) {
    var dlg = root.querySelector('[data-ob-lightbox]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('[data-ob-lb-img]'), stage = dlg.querySelector('[data-ob-lb-stage]');
    var title = dlg.querySelector('[data-ob-lb-title]'), meta = dlg.querySelector('[data-ob-lb-meta]');
    var zoomBtn = dlg.querySelector('[data-ob-lb="zoom"]');
    var list = [], idx = 0, opener = null;
    function setZoom(on, e) {
      dlg.classList.toggle('is-zoomed', on);
      zoomBtn.setAttribute('aria-pressed', String(on));
      if (on && e) pan(e);
    }
    function pan(e) {
      var r = img.getBoundingClientRect();
      img.style.setProperty('--ob-ox', Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100)) + '%');
      img.style.setProperty('--ob-oy', Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100)) + '%');
    }
    function show(i) {
      idx = (i + list.length) % list.length;
      var b = list[idx];
      setZoom(false);
      img.src = b.getAttribute('data-ob-full');
      img.alt = b.getAttribute('data-ob-title') || '';
      title.textContent = b.getAttribute('data-ob-title') || '';
      meta.textContent = b.getAttribute('data-ob-meta') || '';
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ob-zoom]');
      if (!b || !b.getAttribute('data-ob-full')) return;
      var scope = b.closest('section') || root;
      list = [].slice.call(scope.querySelectorAll('[data-ob-zoom]')).filter(function (x) {
        return x.getAttribute('data-ob-full') && !x.closest('[hidden]');
      });
      opener = b;
      show(list.indexOf(b));
      dlg.showModal();
      track('zoom', b.getAttribute('data-ob-title'));
    });
    dlg.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ob-lb]');
      if (a) {
        var k = a.getAttribute('data-ob-lb');
        if (k === 'close') dlg.close();
        else if (k === 'prev') show(idx - 1);
        else if (k === 'next') show(idx + 1);
        else if (k === 'zoom') setZoom(!dlg.classList.contains('is-zoomed'));
        return;
      }
      if (e.target === stage || e.target === img) setZoom(!dlg.classList.contains('is-zoomed'), e);
    });
    stage.addEventListener('pointermove', function (e) { if (dlg.classList.contains('is-zoomed')) pan(e); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null || dlg.classList.contains('is-zoomed')) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
    });
    dlg.addEventListener('close', function () { img.removeAttribute('src'); if (opener) opener.focus(); });
  }

  function compare(root) {
    root.querySelectorAll('[data-ob-compare]').forEach(function (c) {
      var r = c.querySelector('input[type=range]');
      function set() { c.style.setProperty('--ob-pos', r.value + '%'); }
      r.addEventListener('input', set);
      r.addEventListener('change', function () { track('compare', r.value); });
      set();
    });
  }

  function clips(root) {
    var vids = [].slice.call(root.querySelectorAll('.ob-clip__video, .ob-hero__video'));
    function load(v) {
      var s = v.querySelector('source[data-src]');
      if (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); v.load(); }
    }
    vids.forEach(function (v) {
      v.muted = true;
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; load(v); }
    });
    if (reduce) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { load(v); v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { load(v); v.play().catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  // behind the art: film strip / stage + chapters / grid. Prev/next stop at the first and last piece (buttons disabled there).
  function bts(root) {
    var LAYOUTS = ['reel', 'stage', 'grid'], NAMES = { reel: 'Strip', stage: 'Stage + chapters', grid: 'Grid' };
    root.querySelectorAll('[data-ob-bts]').forEach(function (el) {
      if (el.__obBts) return; el.__obBts = true;
      var wrap = el.closest('[data-ob-bts-wrap]') || el;
      var tr = el.querySelector('[data-ob-bts-track]'), count = wrap.querySelector('[data-ob-bts-count]'), ix = el.querySelector('[data-ob-bts-index]');
      var items = [].slice.call(el.querySelectorAll('[data-ob-bts-item]')), gos = [].slice.call(el.querySelectorAll('[data-ob-bts-go]'));
      var prev = wrap.querySelector('[data-ob-bts-step="-1"]'), next = wrap.querySelector('[data-ob-bts-step="1"]');
      var n = items.length, cur = 0, sw = null, pad = function (i) { return (i < 10 ? '0' : '') + i; };
      if (!n || !tr) return;
      var layout = function () { return el.getAttribute('data-layout'); };
      function show() {
        if (count) count.textContent = pad(cur + 1) + ' / ' + pad(n);
        if (prev) prev.disabled = cur === 0;
        if (next) next.disabled = cur === n - 1;
        gos.forEach(function (g, k) { g.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      }
      function go(i, smooth) {
        cur = Math.max(0, Math.min(n - 1, i)); show();
        var beh = smooth && !reduce ? 'smooth' : 'auto';
        if (layout() === 'stage') {
          items.forEach(function (it, k) {
            it.classList.toggle('is-active', k === cur);
            if (k !== cur) it.querySelectorAll('video').forEach(function (v) { v.pause(); });
          });
          tr.style.setProperty('--ar', getComputedStyle(items[cur]).getPropertyValue('--rw').trim() || '1');
          var g = gos[cur];
          if (ix && g && ix.scrollWidth > ix.clientWidth) ix.scrollTo({ left: g.parentNode.offsetLeft, behavior: beh });
        } else if (layout() === 'reel') {
          tr.scrollTo({ left: items[cur].offsetLeft, behavior: beh });
        }
      }
      function setLayout(l) {
        LAYOUTS.forEach(function (x) { el.classList.toggle('ob-bts--' + x, x === l); });
        el.setAttribute('data-layout', l); wrap.setAttribute('data-layout', l);
        fit();
        items.forEach(function (it) { it.classList.remove('is-active'); });
        tr.style.removeProperty('--ar'); tr.scrollLeft = 0;
        go(cur, false);
        if (sw) sw.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.value === l ? 'true' : 'false'); });
      }
      // the whole unit (bar + clips + captions) fits the visible screen below the shop's sticky header, on any monitor
      function headerBottom() {
        // stacked sticky/fixed bars (announcement bar + header): probe below each one until the page content starts
        var y = 0;
        if (!document.elementsFromPoint) return 0;
        for (var i = 0; i < 4; i++) {
          var hit = 0;
          document.elementsFromPoint(innerWidth / 2, y + 2).some(function (n) {
            for (var e = n; e && e !== document.body; e = e.parentElement) {
              var p = getComputedStyle(e).position;
              if ((p === 'fixed' || p === 'sticky') && !wrap.contains(e) && !e.contains(wrap) && !e.closest('[data-ob-root]')) { hit = e.getBoundingClientRect().bottom; return true; }
            }
            return false;
          });
          if (hit <= y + 1) break;
          y = hit;
        }
        return Math.min(y, innerHeight * 0.3);
      }
      function fit() {
        var bar = wrap.querySelector('.ob-bts-bar'), cap = el.querySelector('.ob-caption');
        var reserve = (bar ? bar.offsetHeight : 0) + (cap && layout() === 'reel' ? cap.offsetHeight + 12 : 0) + (layout() === 'stage' ? 48 : 0) + 64;
        var h = Math.round(Math.max(200, Math.min(640, innerHeight - headerBottom() - reserve)));
        wrap.style.setProperty('--h', h + 'px');
        wrap.style.scrollMarginTop = Math.round(headerBottom() + 12) + 'px';
      }
      var ft; window.addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(fit, 120); });
      window.addEventListener('load', function () { fit(); });
      [prev, next].forEach(function (b) {
        if (b) b.addEventListener('click', function () { go(cur + +b.getAttribute('data-ob-bts-step'), true); track('bts_step', String(cur + 1)); });
      });
      gos.forEach(function (g, k) { g.addEventListener('click', function () { go(k, true); }); });
      wrap.addEventListener('keydown', function (e) {
        if (layout() === 'grid' || e.target.closest('input, select, textarea')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(cur + (e.key === 'ArrowRight' ? 1 : -1), true); }
      });
      var st;
      tr.addEventListener('scroll', function () {
        if (layout() !== 'reel') return;
        clearTimeout(st);
        st = setTimeout(function () {
          var x = tr.scrollLeft, best = 0;
          items.forEach(function (it, k) { if (Math.abs(it.offsetLeft - x) < Math.abs(items[best].offsetLeft - x)) best = k; });
          if (x + tr.clientWidth >= tr.scrollWidth - 4) best = n - 1;
          cur = best; show();
        }, 90);
      }, { passive: true });
      // preview only: compare the layouts (the live page shows the layout chosen in the theme editor)
      if (root.hasAttribute('data-preview')) {
        var q = ''; try { q = new URLSearchParams(location.search).get('ob_bts') || ''; } catch (e) {}
        sw = document.createElement('div');
        sw.className = 'ob-bts-switch'; sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Layout (preview only)');
        sw.innerHTML = '<span>Preview · layout</span>' + LAYOUTS.map(function (l) { return '<button type="button" value="' + l + '">' + NAMES[l] + '</button>'; }).join('');
        wrap.parentNode.insertBefore(sw, wrap);
        sw.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) setLayout(b.value); });
        if (LAYOUTS.indexOf(q) > -1) { setLayout(q); return; }
      }
      setLayout(LAYOUTS.indexOf(layout()) > -1 ? layout() : 'reel');
    });
  }

  // soundtrack: one <audio>, starts only on a click, keeps playing while clips or layouts change, stops when the page is left.
  // A clip's own sound and the music never play loud at the same time.
  function soundtrack(root) {
    root.querySelectorAll('[data-ob-st]').forEach(function (el) {
      if (el.__obSt) return; el.__obSt = true;
      var a = el.querySelector('[data-ob-st-audio]'), sel = el.querySelector('[data-ob-st-select]'), play = el.querySelector('[data-ob-st-play]');
      var mute = el.querySelector('[data-ob-st-mute]'), vol = el.querySelector('[data-ob-st-vol]'), now = el.querySelector('[data-ob-st-now]');
      if (!a || !sel || !play) return;
      var opt = function () { return sel.options[sel.selectedIndex]; };
      var label = function () { var o = opt(); return o ? o.textContent.replace(/^Track \d+ — /, '').replace(/ \(audio pending\)$/, '') + (o.getAttribute('data-artist') ? ' · ' + o.getAttribute('data-artist') : '') : ''; };
      function state(msg) {
        var on = !a.paused;
        play.classList.toggle('is-on', on); play.setAttribute('aria-pressed', on ? 'true' : 'false');
        play.setAttribute('aria-label', on ? 'Pause soundtrack' : 'Play soundtrack');
        mute.classList.toggle('is-on', a.muted); mute.setAttribute('aria-pressed', a.muted ? 'true' : 'false');
        mute.setAttribute('aria-label', a.muted ? 'Unmute' : 'Mute');
        var o = opt(); play.disabled = !o || o.hasAttribute('data-missing');
        now.textContent = msg || (o && o.hasAttribute('data-missing') ? 'Audio for this track is not linked yet.' : on ? 'Now playing: ' + label() : a.currentTime > 0 ? 'Paused: ' + label() : 'Selected: ' + label());
      }
      function load() { var o = opt(); if (o && !o.hasAttribute('data-missing') && a.getAttribute('src') !== o.value) a.src = o.value; }
      function start() {
        load(); el.dispatchEvent(new CustomEvent('ob:music-play', { bubbles: true }));
        var p = a.play(); if (p && p.catch) p.catch(function () { state('Playback was blocked by the browser – press play again.'); });
      }
      play.addEventListener('click', function () { if (a.paused) start(); else a.pause(); });
      sel.addEventListener('change', function () { var was = !a.paused; a.pause(); a.removeAttribute('src'); a.load(); if (was) start(); else state(); track('soundtrack', label()); });
      mute.addEventListener('click', function () { a.muted = !a.muted; state(); });
      a.volume = 0.7;
      if (vol) {
        vol.addEventListener('input', function () { a.volume = vol.value / 100; if (a.muted && vol.value > 0) a.muted = false; state(); });
        // iOS ignores audio.volume (hardware buttons only): hide the slider there, mute still works
        a.volume = 0.5; if (a.volume !== 0.5) el.querySelector('[data-ob-st-volwrap]').hidden = true; a.volume = vol.value / 100;
      }
      ['play', 'pause', 'ended', 'volumechange'].forEach(function (ev) { a.addEventListener(ev, function () { state(); }); });
      // playlist: when a song ends the next linked one starts (the visitor already pressed play)
      a.addEventListener('ended', function () {
        var n = sel.options.length, i = sel.selectedIndex;
        for (var k = 1; k <= n; k++) { var o = sel.options[(i + k) % n]; if (!o.hasAttribute('data-missing')) { sel.selectedIndex = o.index; break; } }
        a.removeAttribute('src'); start();
      });
      a.addEventListener('error', function () { if (a.getAttribute('src')) state('This track could not be loaded.'); });
      window.addEventListener('pagehide', function () { a.pause(); });
      root.__obMusic = { pause: function () { a.pause(); }, playing: function () { return !a.paused; } };
      state();
    });
    // clips with their own sound: sound on pauses the soundtrack; music resumes only when the visitor presses play again
    root.querySelectorAll('[data-ob-clip-sound]').forEach(function (b) {
      if (b.__obS) return; b.__obS = true;
      var v = b.parentNode.querySelector('video');
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        root.querySelectorAll('[data-ob-clip-sound][aria-pressed="true"]').forEach(function (o) { if (o !== b) o.click(); });
        if (on && root.__obMusic) root.__obMusic.pause();
        v.muted = !on; if (on) v.play().catch(function () {});
        b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? 'Sound off' : 'Sound on';
      });
    });
    root.addEventListener('ob:music-play', function () {
      root.querySelectorAll('[data-ob-clip-sound][aria-pressed="true"]').forEach(function (b) { b.click(); });
    });
  }

  function countdown(root, now) {
    root.querySelectorAll('[data-ob-countdown]').forEach(function (el) {
      var target = parse(el.getAttribute('data-ob-countdown'));
      if (target === null) return;
      var u = {}; el.querySelectorAll('[data-u]').forEach(function (b) { u[b.getAttribute('data-u')] = b; });
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      (function tick() {
        var s = Math.max(0, Math.floor((target - now()) / 1000));
        if (s === 0) { el.hidden = true; return; }
        el.hidden = false;
        u.d.textContent = pad(Math.floor(s / 86400)); u.h.textContent = pad(Math.floor(s % 86400 / 3600));
        u.m.textContent = pad(Math.floor(s % 3600 / 60)); u.s.textContent = pad(s % 60);
        setTimeout(tick, 1000);
      })();
    });
  }

  function toast(root, msg) {
    var t = root.querySelector('[data-ob-toast]');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3500);
  }

  function cart(root) {
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ob-add]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      btn.disabled = true;
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(form.querySelector('[name=id]').value), quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) {
          return fetch(root_url + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var de = document.documentElement;
            de.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: item, quantity: 1 } }));
            de.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: c } }));
            de.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c, openMiniCart: true } }));
            if (!document.querySelector('cart-drawer, #mini-cart')) toast(root, 'Added to cart');
          });
        })
        .catch(function (err) { toast(root, (err && (err.description || err.message)) || 'Could not add to cart'); })
        .then(function () { btn.disabled = false; });
    });
  }

  function drag(root) {
    root.querySelectorAll('[data-ob-drag]').forEach(function (el) {
      var down = false, x0 = 0, s0 = 0, moved = false;
      el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft; });
      window.addEventListener('pointerup', function () { down = false; });
      el.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = s0 - dx; });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  // Big number (16): counts up and fills with ink every time it scrolls into view
  // Big number: empty at 0, fills up while counting, stays filled at the target. When it has left the screen it is
  // reset (unseen) and builds up again on the next visit.
  function countUp(root) {
    root.querySelectorAll('[data-ob-count]').forEach(function (el) {
      var to = parseInt(el.getAttribute('data-ob-count'), 10);
      if (isNaN(to)) return;
      var digits = String(to).length, raf = 0, state = 'idle', pad = function (n) { n = String(n); while (n.length < digits) n = '0' + n; return n; };
      var fill = function (k) { el.style.backgroundSize = '100% ' + (k * 100).toFixed(1) + '%'; };
      var reset = function () { cancelAnimationFrame(raf); el.textContent = pad(0); fill(0); state = 'idle'; };
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = pad(to); fill(1); return; }
      reset();
      new IntersectionObserver(function (en) {
        var e = en[0];
        if (!e.isIntersecting) { if (state !== 'idle') reset(); return; }
        if (state !== 'idle' || e.intersectionRatio < 0.35) return;
        state = 'run';
        var t0 = performance.now();
        (function step(t) {
          var k = Math.min(1, (t - t0) / 1800), ease = 1 - Math.pow(1 - k, 3);
          el.textContent = pad(Math.round(to * ease)); fill(ease);
          if (k < 1) raf = requestAnimationFrame(step); else state = 'done';
        })(t0);
      }, { threshold: [0, 0.35] }).observe(el);
    });
  }

  // Deep-zoom explorer (canvas): overview image + tile levels, only visible tiles are loaded.
  function deep(root) {
    root.querySelectorAll('[data-ob-deep-root]').forEach(function (el) {
      var stage = el.querySelector('.ob-deep__stage'), cv = el.querySelector('.ob-deep__canvas');
      var ui = el.querySelector('.ob-deep__ui'), mini = el.querySelector('.ob-deep__mini'), label = el.querySelector('[data-ob-deep-label]');
      var ctx = cv.getContext('2d'), mctx = mini.getContext('2d');
      var W = +el.getAttribute('data-w'), H = +el.getAttribute('data-h');
      var levels = []; try { levels = JSON.parse(el.getAttribute('data-levels')); } catch (e) {}
      var spots = (el.getAttribute('data-hotspots') || '').split('\n').map(function (l) {
        var p = l.split(';'); return p.length >= 4 ? { x: +p[0], y: +p[1], z: +p[2], label: p.slice(3).join(';').trim() } : null;
      }).filter(Boolean);
      var small = window.matchMedia('(max-width: 749px)').matches;
      var ov = new Image(); ov.decoding = 'async';
      var cache = {}, active = false, spot = -1, dpr = 1, vw = 0, vh = 0;
      var z = 1, tx = 0, ty = 0, raf = 0, anim = null, lastFocus = null;

      function fitZ() { return Math.min(vw / W, vh / H); }
      function maxZ() { return 1.25; }
      function clamp() {
        var f = fitZ(); z = Math.min(maxZ(), Math.max(f, z));
        var iw = W * z, ih = H * z;
        tx = iw <= vw ? (vw - iw) / 2 : Math.min(0, Math.max(vw - iw, tx));
        ty = ih <= vh ? (vh - ih) / 2 : Math.min(0, Math.max(vh - ih, ty));
      }
      function fit() { z = fitZ(); tx = (vw - W * z) / 2; ty = (vh - H * z) / 2; }
      function resize() {
        var r = stage.getBoundingClientRect(); dpr = Math.min(window.devicePixelRatio || 1, 2);
        var keep = vw ? { cx: (vw / 2 - tx) / z, cy: (vh / 2 - ty) / z, rel: z / fitZ() } : null;
        vw = r.width; vh = r.height; cv.width = Math.round(vw * dpr); cv.height = Math.round(vh * dpr);
        if (keep && active) { z = keep.rel * fitZ(); tx = vw / 2 - keep.cx * z; ty = vh / 2 - keep.cy * z; clamp(); } else fit();
        draw();
      }
      function tile(L, li, c, r) {
        var k = li + '-' + c + '-' + r, t = cache[k];
        if (!t) {
          t = cache[k] = { img: new Image(), ok: false };
          t.img.decoding = 'async';
          t.img.onload = function () { t.ok = true; draw(); };
          t.img.src = L.urls[c * L.rows + r];
        }
        return t;
      }
      function draw() {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          ctx.fillStyle = '#000'; ctx.fillRect(0, 0, vw, vh);
          ctx.imageSmoothingQuality = 'high';
          if (ov.complete && ov.naturalWidth) ctx.drawImage(ov, tx, ty, W * z, H * z);
          var need = W * z * dpr;
          levels.forEach(function (L, li) {
            var prevW = li === 0 ? ov.naturalWidth || 2400 : levels[li - 1].w;
            if (!active || need < prevW * 1.1) return;
            var s = W / L.w, ts = L.tile * s * z;
            var c0 = Math.max(0, Math.floor(-tx / ts)), c1 = Math.min(L.cols - 1, Math.floor((vw - tx) / ts));
            var r0 = Math.max(0, Math.floor(-ty / ts)), r1 = Math.min(L.rows - 1, Math.floor((vh - ty) / ts));
            for (var c = c0; c <= c1; c++) for (var r = r0; r <= r1; r++) {
              var t = tile(L, li, c, r);
              if (t.ok) ctx.drawImage(t.img, tx + c * ts, ty + r * ts, t.img.naturalWidth * s * z, t.img.naturalHeight * s * z);
            }
          });
          if (active) drawMini();
        });
      }
      function drawMini() {
        var mw = mini.clientWidth, mh = mw * H / W, md = dpr;
        if (mini.width !== Math.round(mw * md)) { mini.width = Math.round(mw * md); mini.height = Math.round(mh * md); }
        mctx.setTransform(md, 0, 0, md, 0, 0); mctx.clearRect(0, 0, mw, mh);
        if (ov.complete && ov.naturalWidth) mctx.drawImage(ov, 0, 0, mw, mh);
        var k = mw / W, x = -tx / z * k, y = -ty / z * k, w = vw / z * k, h = vh / z * k;
        mctx.strokeStyle = '#f6f3ed'; mctx.lineWidth = 2;
        mctx.fillStyle = 'rgba(0,0,0,.35)';
        mctx.fillRect(0, 0, mw, Math.max(0, y)); mctx.fillRect(0, y + h, mw, mh); mctx.fillRect(0, y, Math.max(0, x), h); mctx.fillRect(x + w, y, mw, h);
        mctx.strokeRect(Math.max(1, x), Math.max(1, y), Math.min(w, mw - 2), Math.min(h, mh - 2));
      }
      function zoomAt(f, sx, sy) {
        var nz = Math.min(maxZ(), Math.max(fitZ(), z * f)); f = nz / z;
        tx = sx - (sx - tx) * f; ty = sy - (sy - ty) * f; z = nz; clamp(); draw();
      }
      function flyTo(cx1, cy1, nz, ms) {
        nz = Math.min(maxZ(), Math.max(fitZ(), nz));
        var s0 = { z: z, cx: (vw / 2 - tx) / z, cy: (vh / 2 - ty) / z }, t0 = performance.now(); ms = reduce ? 0 : ms || 900;
        cancelAnimationFrame(anim);
        (function step(now) {
          var k = ms ? Math.min(1, (now - t0) / ms) : 1, e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
          z = Math.exp(Math.log(s0.z) + (Math.log(nz) - Math.log(s0.z)) * e);
          var cx = s0.cx + (cx1 - s0.cx) * e, cy = s0.cy + (cy1 - s0.cy) * e;
          tx = vw / 2 - cx * z; ty = vh / 2 - cy * z; clamp(); draw();
          if (k < 1) anim = requestAnimationFrame(step);
        })(t0);
      }
      function go(i) {
        if (!spots.length) return;
        spot = (i + spots.length) % spots.length;
        var s = spots[spot];
        label.textContent = (spot < 9 ? '0' : '') + (spot + 1) + ' / ' + spots.length + ' · ' + s.label;
        flyTo(s.x * W, s.y * H, fitZ() * s.z, 1100);
        track('explore_detail', s.label);
      }
      function open() {
        if (active) return;
        active = true; lastFocus = document.activeElement;
        el.classList.add('is-active'); ui.hidden = false;
        document.documentElement.classList.add('ob-noscroll');
        if (!small && ov.getAttribute('data-full') !== '1') { ov.setAttribute('data-full', '1'); ov.src = el.getAttribute('data-ov'); }
        resize(); label.textContent = spots.length ? 'Guided tour · ' + spots.length + ' details →' : '';
        el.querySelector('[data-ob-deep="close"]').focus();
        track('explore_open', '');
      }
      function close() {
        if (!active) return;
        active = false; el.classList.remove('is-active'); ui.hidden = true;
        document.documentElement.classList.remove('ob-noscroll');
        cancelAnimationFrame(anim); resize();
        if (lastFocus) lastFocus.focus();
      }
      // pointers: drag to pan, two fingers to pinch
      var pts = new Map(), pinch = null, moved = false, downAt = null;
      stage.addEventListener('pointerdown', function (e) {
        if (!active) return;
        stage.setPointerCapture(e.pointerId); pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        moved = false; downAt = { x: e.clientX, y: e.clientY }; cancelAnimationFrame(anim);
        if (pts.size === 2) { var a = Array.from(pts.values()); pinch = { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), z: z }; }
      });
      stage.addEventListener('pointermove', function (e) {
        if (!active || !pts.has(e.pointerId)) return;
        var p = pts.get(e.pointerId), r = stage.getBoundingClientRect();
        if (pts.size === 1) { tx += e.clientX - p.x; ty += e.clientY - p.y; clamp(); draw(); }
        p.x = e.clientX; p.y = e.clientY;
        if (downAt && Math.hypot(e.clientX - downAt.x, e.clientY - downAt.y) > 5) moved = true;
        if (pts.size === 2 && pinch) {
          var a = Array.from(pts.values()), d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
          zoomAt(pinch.z * d / pinch.d / z, (a[0].x + a[1].x) / 2 - r.left, (a[0].y + a[1].y) / 2 - r.top);
        }
      });
      function up(e) { pts.delete(e.pointerId); if (pts.size < 2) pinch = null; }
      stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);
      stage.addEventListener('dblclick', function (e) { if (!active) return; var r = stage.getBoundingClientRect(); zoomAt(2, e.clientX - r.left, e.clientY - r.top); });
      stage.addEventListener('wheel', function (e) {
        if (!active) return; e.preventDefault();
        var r = stage.getBoundingClientRect(); zoomAt(Math.exp(-e.deltaY * (e.deltaMode ? 0.05 : 0.0018)), e.clientX - r.left, e.clientY - r.top);
      }, { passive: false });
      document.addEventListener('keydown', function (e) {
        if (!active) return;
        var k = e.key, step = 80;
        if (k === 'Escape') close();
        else if (k === '+' || k === '=') zoomAt(1.4, vw / 2, vh / 2);
        else if (k === '-') zoomAt(1 / 1.4, vw / 2, vh / 2);
        else if (k === '0') { fit(); draw(); }
        else if (k === 'ArrowRight' && e.shiftKey) go(spot + 1);
        else if (k === 'ArrowLeft' && e.shiftKey) go(spot - 1);
        else if (k.indexOf('Arrow') === 0) { tx += k === 'ArrowLeft' ? step : k === 'ArrowRight' ? -step : 0; ty += k === 'ArrowUp' ? step : k === 'ArrowDown' ? -step : 0; clamp(); draw(); }
        else return;
        e.preventDefault();
      });
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ob-deep]'); if (!b || !el.contains(b)) return;
        var a = b.getAttribute('data-ob-deep');
        if (a === 'in') zoomAt(1.6, vw / 2, vh / 2); else if (a === 'out') zoomAt(1 / 1.6, vw / 2, vh / 2);
        else if (a === 'fit') flyTo(W / 2, H / 2, fitZ(), 700); else if (a === 'close') close();
        else if (a === 'next') go(spot + 1); else if (a === 'prev') go(spot - 1);
      });
      root.querySelectorAll('[data-ob-deep-open]').forEach(function (b) { if ('ob-deep-' + b.getAttribute('data-ob-deep-open') === el.id) b.addEventListener('click', open); });
      function miniJump(e) { var r = mini.getBoundingClientRect(); flyTo((e.clientX - r.left) / r.width * W, (e.clientY - r.top) / r.height * H, z, 350); }
      mini.addEventListener('pointerdown', function (e) { if (active) { e.stopPropagation(); miniJump(e); } });
      ov.onload = draw;
      var start = function () { if (!ov.src) ov.src = el.getAttribute(small ? 'data-ov-sm' : 'data-ov'); resize(); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '600px' }); io.observe(el);
      } else start();
      window.addEventListener('resize', function () { if (vw) resize(); });
    });
  }

  // shared test link: password gate (hash comparison, remembered for the browser session)
  function gate(root, done) {
    var want = root.getAttribute('data-ob-gate'), key = 'ob-gate-' + want.slice(0, 12);
    try { if (sessionStorage.getItem(key) === '1') return done(); } catch (e) {}
    var box = document.createElement('form');
    box.className = 'ob-gate';
    box.innerHTML = '<p class="ob-label">Protected preview</p><h1 class="ob-h2">OFFALS &amp; BONES</h1>' +
      '<p>Test version for the team. Please enter the password.</p>' +
      '<div class="ob-gate__row"><label class="ob-visually-hidden" for="ob-gate-pw">Password</label>' +
      '<input id="ob-gate-pw" type="password" autocomplete="current-password" required>' +
      '<button type="submit" class="ob-bts__step">Open</button></div><p class="ob-gate__err" aria-live="polite"></p>';
    root.appendChild(box);
    var inp = box.querySelector('input'), err = box.querySelector('.ob-gate__err');
    try { inp.focus({ preventScroll: true }); } catch (e3) { inp.focus(); }
    box.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = inp.value.replace(/[\s.]/g, '');
      if (!(window.crypto && crypto.subtle)) { err.textContent = 'This browser cannot open the preview.'; return; }
      crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(function (buf) {
        var hex = [].map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        if (hex !== want) { err.textContent = 'Wrong password.'; inp.select(); return; }
        try { sessionStorage.setItem(key, '1'); } catch (e2) {}
        inp.blur(); box.remove(); done();
        // the on-screen keyboard (iOS) scrolls the page while typing – start the opened page at the very top
        window.scrollTo(0, 0); setTimeout(function () { window.scrollTo(0, 0); }, 350);
      });
    });
  }

  // in-page links (#ob-signup, #ob-tour …): scroll ourselves, so the store theme's own anchor handling cannot swallow them
  function anchors(root) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]'); if (!a || !root.contains(a)) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1)); if (!id || /^frame-/.test(id)) return;
      var t = document.getElementById(id); if (!t) return;
      e.preventDefault(); e.stopPropagation();
      if (a.hasAttribute('data-ob-track')) track(a.getAttribute('data-ob-track'), a.getAttribute('data-ob-track-label') || a.textContent.trim());
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { history.replaceState(null, '', '#' + id); } catch (e2) {}
      var f = t.querySelector('input[type=email]'); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e3) {} }, reduce ? 0 : 600);
    }, true);
  }

  // early access sign-up straight into one Klaviyo list (client subscription API; the list's opt-in rules apply)
  function klaviyo(root) {
    root.querySelectorAll('form[data-ob-klaviyo]').forEach(function (f) {
      if (f.__ob) return; f.__ob = true;
      var inp = f.querySelector('input[type=email]'), btn = f.querySelector('button'), ok = f.querySelector('.ob-form__ok'), err = f.querySelector('.ob-form__err'), row = f.querySelector('.ob-form__row');
      f.addEventListener('submit', function (e) {
        e.preventDefault(); err.hidden = true;
        var v = (inp.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; inp.focus(); return; }
        btn.disabled = true;
        var body = { data: { type: 'subscription', attributes: { custom_source: f.getAttribute('data-source') || 'OFFALS & BONES', profile: { data: { type: 'profile', attributes: { email: v } } } },
          relationships: { list: { data: { type: 'list', id: f.getAttribute('data-list') } } } } };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(f.getAttribute('data-company')), {
          method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          row.hidden = true; ok.hidden = false; track('signup_ok', 'klaviyo');
        }).catch(function () { err.textContent = 'That did not work. Please try again in a moment.'; err.hidden = false; btn.disabled = false; });
      });
    });
  }

  // terms dialogs (tour stop prize draw): button[data-ob-dialog=id] opens <dialog id>; closes on backdrop click
  if (!window.__obDialogs) {
    window.__obDialogs = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ob-dialog]');
      if (b) { var d = document.getElementById(b.getAttribute('data-ob-dialog')); if (d && d.showModal && !d.open) { e.preventDefault(); d.showModal(); track(b.getAttribute('data-ob-track') || 'dialog_open', b.getAttribute('data-ob-track-label') || ''); } return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('ob-terms')) { var r = e.target.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close(); }
    });
  }

  // Live page, phase "auto": whoever has the page open at a switch moment (LIVE start, POST-EXHIBITION start) gets the new
  // phase without reloading by hand – a fresh, cache-busted request a few seconds after the moment (owner 03.11.).
  function phaseTimer(root) {
    if (root.__obTimer) return; root.__obTimer = true;
    var order = ['prelaunch', 'live', 'archive'], shown = order.indexOf(root.getAttribute('data-phase'));
    var next = null;
    if (shown < 1) next = parse(root.getAttribute('data-live'));
    if (next === null && shown < 2) next = parse(root.getAttribute('data-archive'));
    if (next === null) return;
    var wait = next - Date.now() + 3000;
    if (wait <= 0 || wait > 2147483000) return;
    function go() {
      if (document.visibilityState === 'hidden') { document.addEventListener('visibilitychange', go, { once: true }); return; }
      var u = new URL(location.href); u.searchParams.set('ob_t', String(Math.floor(Date.now() / 1000)));
      location.replace(u.toString());
    }
    setTimeout(go, wait);
  }

  function init(root) {
    if (root.hasAttribute('data-ob-gate') && !root.__obOpen) { return gate(root, function () { root.__obOpen = true; init(root); }); }
    if (root.hasAttribute('data-preview')) mountPreview(root);
    else if (root.getAttribute('data-mode') === 'auto') {
      var should = phaseAt(root, Date.now()), shown = root.getAttribute('data-phase'), order = ['prelaunch', 'live', 'archive'];
      if (order.indexOf(should) > order.indexOf(shown)) {
        var key = 'ob-reload-' + should, done = true;
        try { done = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (e) {}
        if (!done) { var u = new URL(location.href); u.searchParams.set('ob_t', String(Math.floor(Date.now() / 60000))); location.replace(u.toString()); return; }
      }
      phaseTimer(root);
    }
    root.classList.add('ob-js');
    if (!root.__obAnchors) { root.__obAnchors = true; anchors(root); }
    klaviyo(root);
    reveal(root); parallax(root); filters(root); lightbox(root); compare(root); clips(root);
    countdown(root, Date.now); cart(root); drag(root); countUp(root); deep(root); bts(root); soundtrack(root);
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ob-track]');
      if (a && a.tagName === 'A') track(a.getAttribute('data-ob-track'), a.getAttribute('data-ob-track-label') || a.textContent.trim());
    });
  }

  function boot() { document.querySelectorAll('[data-ob-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ob-root]'); if (r) init(r); });
})();

/* Stop & Pick teaser: play the device videos only while visible (no autoplay cost off screen) */
(function () {
  function init() {
    var vids = document.querySelectorAll('[data-ob-sp-video]'); if (!vids.length || !('IntersectionObserver' in window)) return;
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting && !reduced) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: .2 });
    vids.forEach(function (v) { if (v.__obsp) return; v.__obsp = 1; v.removeAttribute('autoplay'); v.pause(); io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if ('MutationObserver' in window) new MutationObserver(function () { if (document.querySelector('[data-ob-sp-video]:not([data-obsp])')) { document.querySelectorAll('[data-ob-sp-video]').forEach(function (v) { v.setAttribute('data-obsp', ''); }); init(); } }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Stop & Pick teaser: the device videos play only while visible */
(function () {
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches, io = null;
  function init() {
    if (!('IntersectionObserver' in window)) return;
    io = io || new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting && !reduced) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: .2 });
    document.querySelectorAll('[data-ob-sp-video]:not([data-obsp])').forEach(function (v) { v.setAttribute('data-obsp', ''); io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // the preview mounts the page content late – pick the videos up when they appear
  if ('MutationObserver' in window) new MutationObserver(function () { if (document.querySelector('[data-ob-sp-video]:not([data-obsp])')) init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* We come to your town: sound toggle for the muted teaser film */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-ob-sound]'); if (!b) return;
  var v = b.parentNode.querySelector('video'); if (!v) return;
  v.muted = !v.muted; b.setAttribute('aria-pressed', String(!v.muted)); b.textContent = v.muted ? 'Sound on' : 'Sound off';
  if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
});
